/* global grecaptcha */

import React, {useContext, useEffect, useRef, useState} from 'react'
import {GoogleLogin} from '@react-oauth/google'

import {Context} from '../Data/Context/Context'
import {RECAPTCHA_SITE_KEY} from '../Data/Constants'
import './LoginModal.css'
import ReactGA from "react-ga";
import ym from "react-yandex-metrika";

export default function LoginModal(props) {
    const {getLoginModalState, setLoginModalState, onLoginClick, onRegisterClick, onGoogleLogin } = useContext(Context)
    const [isRegister, setRegister] = useState(false)
    const [regEmail, setRegEmail] = useState('')
    const [regPass, setRegPass] = useState('')
    const [regPassConfirm, setRegPassConfirm] = useState('')
    const [regPhone, setRegPhone] = useState('')
    const [loginEmail, setLoginEmail] = useState('')
    const [loginPass, setLoginPass] = useState('')
    const [regEmailError, setRegEmailError] = useState('')
    const [regPassError, setRegPassError] = useState('')
    const [regPhoneError, setRegPhoneError] = useState('')
    const [recaptchaToken, setRecaptchaToken] = useState('')
    const recaptchaContainerRef = useRef(null)
    const recaptchaWidgetIdRef = useRef(null)

    useEffect(() => {
        const trackingId = "UA-26878841-2"; // Replace with your Google Analytics tracking ID
        ReactGA.initialize(trackingId);
        ReactGA.pageview(window.location.pathname + window.location.search);

        ym('hit', '/login')
    }, [])

    const modalOpen = getLoginModalState()

    // Load reCAPTCHA script once
    useEffect(() => {
        if (typeof window.grecaptcha !== 'undefined' && window.grecaptcha.render) return
        const script = document.createElement('script')
        script.src = 'https://www.google.com/recaptcha/api.js?render=explicit'
        script.async = true
        script.defer = true
        document.head.appendChild(script)
    }, [])

    // Render reCAPTCHA widget when register form opens
    useEffect(() => {
        if (!isRegister || !recaptchaContainerRef.current) return
        const checkReady = setInterval(() => {
            if (typeof window.grecaptcha !== 'undefined' && window.grecaptcha.render) {
                clearInterval(checkReady)
                recaptchaWidgetIdRef.current = grecaptcha.render(recaptchaContainerRef.current, {
                    sitekey: RECAPTCHA_SITE_KEY,
                    callback: (token) => setRecaptchaToken(token),
                    'expired-callback': () => setRecaptchaToken('')
                })
            }
        }, 200)
        return () => clearInterval(checkReady)
    }, [isRegister])

    useEffect(() => {
        if (modalOpen) {
            setRegister(false)
            setRegEmail('')
            setRegPass('')
            setRegPassConfirm('')
            setRegPhone('')
            setLoginEmail('')
            setLoginPass('')
            setRegEmailError('')
            setRegPassError('')
            setRegPhoneError('')
            setRecaptchaToken('')
            recaptchaWidgetIdRef.current = null
        }
    }, [modalOpen])

    useEffect(() => {
        const onEsc = e => { if (e.key === 'Escape') setLoginModalState(false) }
        window.addEventListener('keydown', onEsc)
        return () => window.removeEventListener('keydown', onEsc)
    }, [setLoginModalState])

    const handleRegister = async () => {
        setRegEmailError('')
        setRegPassError('')
        setRegPhoneError('')

        let valid = true

        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(regEmail)) {
            setRegEmailError('Некорректный email')
            valid = false
        }

        if (regPass.length < 6) {
            setRegPassError('Пароль должен быть минимум 6 символов')
            valid = false
        } else if (regPass !== regPassConfirm) {
            setRegPassError('Пароли не совпадают')
            valid = false
        }

        if (regPhone && !/^\+\d{11}$/.test(regPhone)) {
            setRegPhoneError('Формат: +XXXXXXXXXXX (11 цифр)')
            valid = false
        }

        if (!valid) return

        if (!recaptchaToken) {
            setRegEmailError('Пожалуйста, пройдите проверку "Я не робот"')
            return
        }

        const result = await onRegisterClick(regEmail, regPass, regPhone, recaptchaToken)
        if (result === true) {
            setLoginModalState(false)
        } else if (result === 'exists') {
            setRegEmailError('Пользователь с таким email уже существует')
        } else {
            setRegEmailError('Ошибка регистрации. Попробуйте ещё раз.')
        }
    }

    const handleLogin = async () => {
        const ok = await onLoginClick(loginEmail, loginPass)
        if (ok) setLoginModalState(false)
    }

    const switchToLogin = () => {
        setRegister(false)
        setRegEmail('')
        setRegPass('')
        setRegPassConfirm('')
        setRegPhone('')
        setRegEmailError('')
        setRegPassError('')
        setRegPhoneError('')
        setRecaptchaToken('')
        recaptchaWidgetIdRef.current = null
    }

    return (
        <React.Fragment>
            {getLoginModalState() && (<div className="modal">
                <div className={"modalBody" + (isRegister ? " modalBody--register" : "")}>
                    {isRegister ? (
                        <form name="registerForm" autoComplete="off" onSubmit={e => { e.preventDefault(); handleRegister() }}>
                            <center>
                                <div className="header">Регистрация</div>
                            </center>
                            <div className="field-wrap">
                                <input className="input" placeholder="e-mail"
                                    value={regEmail}
                                    onChange={e => setRegEmail(e.target.value)}/>
                                <div className={`field-error${regEmailError ? '' : ' field-error--empty'}`}>{regEmailError || '\u00A0'}</div>
                            </div>
                            <div className="field-wrap">
                                <input type="password" className="input" placeholder="Пароль" autoComplete="new-password"
                                    value={regPass}
                                    onChange={e => setRegPass(e.target.value)}/>
                                <div className="field-error field-error--empty">{'\u00A0'}</div>
                            </div>
                            <div className="field-wrap">
                                <input type="password" className="input" placeholder="Подтвердите пароль" autoComplete="new-password"
                                    value={regPassConfirm}
                                    onChange={e => setRegPassConfirm(e.target.value)}/>
                                <div className={`field-error${regPassError ? '' : ' field-error--empty'}`}>{regPassError || '\u00A0'}</div>
                            </div>
                            <div className="field-wrap">
                                <input className="input" placeholder="Телефон (необязательно)"
                                    value={regPhone}
                                    onChange={e => setRegPhone(e.target.value)}/>
                                <div className={`field-error${regPhoneError ? '' : ' field-error--empty'}`}>{regPhoneError || '\u00A0'}</div>
                            </div>
                            <center>
                                <div ref={recaptchaContainerRef}></div>
                            </center>
                            <center>
                                <button type="submit" className="button button-wide">Регистрация</button>
                            </center>
                            <center>
                                <div className="button" onClick={switchToLogin}>Назад</div>
                            </center>
                        </form>
                    ) : (
                        <React.Fragment>
                            <form name="loginForm" autoComplete="off" onSubmit={e => { e.preventDefault(); handleLogin() }}>
                                <center>
                                    <div className="header">Хочу свою цену</div>
                                </center>
                                <input className="input" placeholder="e-mail"
                                    value={loginEmail}
                                    onChange={e => setLoginEmail(e.target.value)}/>
                                <input type="password" className="input" placeholder="Пароль" autoComplete="new-password"
                                    value={loginPass}
                                    onChange={e => setLoginPass(e.target.value)}/>
                                <center style={{display: 'flex', gap: '10px', justifyContent: 'center'}}>
                                    <button type="submit" className="button">Войти</button>
                                    <div className="button button-wide" onClick={() => setRegister(true)}>Регистрация</div>
                                </center>
                            </form>
                            <div className="oauth-divider">
                                <span>или</span>
                            </div>
                            <center>
                                <GoogleLogin
                                    onSuccess={credentialResponse => {
                                        onGoogleLogin(credentialResponse);
                                        setLoginModalState(false);
                                    }}
                                    onError={() => {}}
                                    size="large"
                                    shape="pill"
                                    text="signin_with"
                                />
                            </center>
                            <center>
                                <div className="button" onClick={() => setLoginModalState(false)}>Скрыть</div>
                            </center>
                        </React.Fragment>
                    )}
                </div>
            </div>)}
        </React.Fragment>

    )
}
